module.exports = __webpack_public_path__ + "media/images/icons/hut-f2f8d65b3628037e510009262c39c674.svg";